import { Fetch } from '../../shared/types';
import { AppMetadataPage, AppMetadata } from '../types';

const PAGE_SIZE_LIMIT = 500;

type PageParams = {
  limit: number;
  offset: number;
};

const getPrivateAppsPage = async (
  fetch: Fetch,
  { limit, offset }: PageParams
): Promise<AppMetadataPage> => {
  const data = await fetch<any>('/api/v4/implementations-meta/private/', {
    params: { limit, offset },
  });
  return data;
};

export const getPrivateApps = async (fetch: Fetch): Promise<AppMetadata[]> => {
  const data: AppMetadata[] = [];
  let hasNextPage = true;
  let page = 0;

  while (hasNextPage) {
    const privateAppMetadata = await getPrivateAppsPage(fetch, {
      limit: PAGE_SIZE_LIMIT,
      offset: page * PAGE_SIZE_LIMIT,
    });

    if (privateAppMetadata?.results) {
      data.push(...privateAppMetadata.results);
    }

    if (privateAppMetadata?.next) {
      page++;
    } else {
      hasNextPage = false;
    }
  }

  return data;
};

export default getPrivateApps;
